import React, { useEffect } from 'react';
import { FormattedMessage } from 'react-intl';
import { useNavigate, useParams } from 'react-router-dom';
import Button from 'carbon-react/lib/components/button';

import { ROUTES, getForecastByIdOnboardingUrl } from '@futrli/shared-services';

import { OnboardingPageTitle } from '../components/onboarding-page-title';
import * as styles from '../forecasting-onboarding.scss';
import { OnboardingPredictionsRouter } from '../components/onboarding-predictions-router';
import {
  BUDGET_ONBOARDING_STEP,
  LS_FORECASTING_ONBOARDING_STEP,
  SCENARIO_ONBOARDING_STEP,
  SCENARIO_WITH_INVOICES_ONBOARDING_STEP
} from '../const';
import { useExpandAllRows, useOnboardingUrlInfo } from '../utils/hooks';
import { usePredictionsInfoContext } from '../../detail/context/predictions-info-context';

export const OnboardingExplained = () => {
  const { workspaceId: tempWorkspaceId, organisationId: tempOrganisatioId } = useParams();
  const workspaceId = tempWorkspaceId || '';
  const organisationId = tempOrganisatioId || '';
  const { forecast, setPredictionsExplanations } = usePredictionsInfoContext();

  const navigate = useNavigate();

  useEffect(() => {
    setPredictionsExplanations?.();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useExpandAllRows();

  const {
    isOnboardingBudgetRoute,
    isOnboardingScenarioRoute,
    isOnboardingScenarioWithInvoicesRoute
  } = useOnboardingUrlInfo();

  const handleNextClick = () => {
    if (!forecast) {
      return;
    }

    let nextStep;
    if (isOnboardingBudgetRoute) {
      nextStep = BUDGET_ONBOARDING_STEP.AUTO_PREDICTIONS_CUSTOMISE;
    } else if (isOnboardingScenarioRoute) {
      nextStep = SCENARIO_ONBOARDING_STEP.AUTO_PREDICTIONS_HISTORICAL;
    } else {
      nextStep = SCENARIO_WITH_INVOICES_ONBOARDING_STEP.AUTO_PREDICTIONS_HISTORICAL;
    }
    navigate(
      `${getForecastByIdOnboardingUrl(
        workspaceId,
        organisationId,
        forecast.id,
        isOnboardingBudgetRoute,
        isOnboardingScenarioWithInvoicesRoute
      )}/${nextStep}${ROUTES.SALES}${location.search}`
    );

    localStorage.setItem(LS_FORECASTING_ONBOARDING_STEP, BUDGET_ONBOARDING_STEP.AUTO_PREDICTIONS_CUSTOMISE);
  };

  return (
    <div className={styles.contentContainer} style={{ position: 'relative' }}>
      <OnboardingPageTitle
        title={
          <FormattedMessage
            id="onboarding.where_number_come_from"
            defaultMessage="Where’s that number come from? They are explained here..."
          />
        }
        description={
          <FormattedMessage
            id="onboarding.toggle_off_any_predictions_where_you_know_more_than_futrli"
            defaultMessage="<b>Toggle off</b> any predictions where you know more than Futrli does. You can complete this after this guided flow. "
            values={{
              b: (chunks: string) => <span style={{ fontWeight: 500 }}>{chunks}</span>
            }}
          />
        }
      />
      <Button mb="30px" buttonType="primary" size="large" onClick={handleNextClick}>
        <FormattedMessage id="common.next" defaultMessage="Next" />
      </Button>
      <OnboardingPredictionsRouter />
    </div>
  );
};
